import {main} from './main'
main('huasan-6gaadaha7ceb62a9', 1)
